<template>
    <div>
        <form @submit.prevent="update">
            <preloader v-if="loading"></preloader>
            <form-question :question="question" :errors="errors" ></form-question>
            <div class="columns">
                <div class="column">
                    <div class="block">
                        <div class="field is-grouped">
                            <p class="control">
                                <button class="button is-success" type="submit">Actualizar</button>
                            </p>
                            <p class="control" >
                                <button class="button" type="reset" @click="cancel">Cancelar</button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "Edit",
        data() {
            return {
                loading: false,
                errors: {},
                question: {},
                ready: false,
            }
        },
        props:{
            uuid: String,
        },
        mounted() {
            this.prepareComponent();
        },
        beforeRouteEnter (to, from, next) {
            next(vm => vm.prepareComponent())
        },
        methods: {
            prepareComponent() {
                this.loading = false;
                this.$root.preloader = false;
                this.getQuestion();
            },
            update() {
                this.$loader.show();
                this.errors = {};
                var questionData ={
                    "content":this.question.content,
                    "type":this.question.type,
                    "poll_id":this.question.poll.id,
                    "order":this.question.order,
                };

                this.$http.put('/ivr/question/' + this.question.uuid, questionData).then(({data}) => {

                    console.log(data);
                    this.$notify.success(data);
                    this.$loader.hide();
                    this.$router.back();
                }, ({response}) => {
                    this.$loader.hide();
                    let data = response.data || {};
                    this.errors = data.errors || {};
                    this.$notify.danger(data.data.message);
                })
            },
            cancel() {
                this.$emit('cancel');
                this.$router.push(`/admin/ivr/poll/`);
            },
            getQuestion() {
                this.ready = false;
                this.$http.get('/ivr/question/' + this.uuid).then(response => {
                    this.question = response.data.data;
                    setTimeout(() => {
                        this.ready = true;
                    }, 500)
                }, error => {
                    this.ready = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>